import * as React from "react";
import Form from "./Form";
import FormDialog from "../../../components/Dialog/FormDialog";

function DialogCreateBoard({ handleClose, open }) {
  return (
    <React.Fragment>
      <FormDialog
        handleClose={handleClose}
        fullWidth={true}
        open={open}
        title={"Create Board"}>
        <Form onClose={handleClose} />
      </FormDialog>
    </React.Fragment>
  );
}

export default React.memo(DialogCreateBoard);
